export enum UserRoleEnum {
    COMPANY = 1,
    PRIVATE = 2,
    MANAGER = 3,
    ASSOCIATION = 4
}
